import React from 'react';
import styles from './home-services-cards.module.css';
import Link from 'gatsby-link';
import Logos from '../../../../components/logos';
import { replaceBreakWithSpace } from '../../../../utils/helper-functions';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';

const HomeServicesCards = props => {
  const { servicesWithMultiplier, isInView } = props;
  return (
    <div className={styles.services}>
      {servicesWithMultiplier.map((service, index) => {
        const { title, slug, acf } = service.node;
        const animationConfig = {
          duration: 1000,
          easing: easings.easeCubicOut,
        };
        return (
          <Spring
            key={index}
            from={{ opacity: '0' }}
            to={{
              opacity: isInView ? '1' : '0',
            }}
            config={animationConfig}
            delay={servicesWithMultiplier[index].multiplier}
          >
            {animation => {
              return (
                <Link
                  to={`capabilities/${slug}`}
                  className={styles.card}
                  style={{ opacity: animation.opacity }}
                >
                  <div className={styles.cardBG} />
                  <div className={styles.cardLogo}>
                    <Logos slug={slug} />
                  </div>
                  <h3
                    className={styles.title}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                  <ul className={styles.internalInfoList}>
                    {acf.internal_info.map((info, index) => {
                      return (
                        <li
                          key={index}
                          className={styles.infoTitle}
                          dangerouslySetInnerHTML={{
                            __html: replaceBreakWithSpace(info.title),
                          }}
                        />
                      );
                    })}
                  </ul>
                  <span className={styles.learn}>Learn More</span>
                </Link>
              );
            }}
          </Spring>
        );
      })}
    </div>
  );
};

export default HomeServicesCards;



// WEBPACK FOOTER //
// ./src/components/home/home-services/home-services-cards/index.js